export default (function (callback) {
  if (window.FB) {
    var auth = function auth(_ref) {
      var authResponse = _ref.authResponse;
      window.FB.api('/me', function (response) {
        callback(authResponse, response);
      });
    };

    window.FB.login(auth, {
      auth_type: 'reauthorize'
    });
  }
});